import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {getEdge365ChallengeTasks} from '/redux/action/coach.action';
import {
  hasEdge365ChallengeTasksById,
  hasNextRankById,
  highestStreak,
  latestStreak,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {fromProps, withProps} from '/util/selector.util';

import PerformanceTab from './PerformanceTab';

const withCoachId = withProps({
  coachId: fromProps(get('coachId')),
});

export default connect(
  createStructuredSelector({
    hasNextRank: hasNextRankById,
    latestStreakData: withCoachId(latestStreak),
    highestStreakData: withCoachId(highestStreak),
    userId,
    hasEdge365ChallengeTasks: withCoachId(hasEdge365ChallengeTasksById),
  }),
  dispatch => ({
    getEdge365ChallengeTasks: ({
      coachId,
      month,
      year,
    }: {
      coachId: any;
      month: number;
      year: number;
    }) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getEdge365ChallengeTasks({coachId, month, year})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      getEdge365ChallengeTasks: ({
        month,
        year,
        coachId,
      }: {
        month: number;
        year: number;
      }) => {
        return dispatchProps.getEdge365ChallengeTasks({
          coachId,
          month,
          year,
        });
      },
    };
  },
)(PerformanceTab);
